import { Vue, Component } from 'vue-property-decorator'
import { v4 as uuidv4 } from 'uuid'
import carritos from '@/store/modules/CarritoModule'
import auth from '@/store/modules/AuthModule'

@Component
export default class CarritoPage extends Vue {
  step = 1
  carrito = carritos.service.getEmpty(uuidv4())

  next () {
    this.step = 2
  }

  get items () {
    return carritos.items
  }

  get total () {
    return carritos.total.toFixed(2)
  }

  get isAuth () {
    return auth.isAuth
  }

  onDelete (id: string) {
    carritos.removeIem(id)
  }

  onBuscarCliente () {
    carritos.service.getDatosCliente(this.carrito.cliente.documento_identidad).then((response) => {
      if (this.carrito.cliente.documento_identidad.length === 8) {
        this.carrito.cliente.nombre = response.data.nombre + ' ' + response.data.apepat + ' ' + response.data.apemat
      }
    })
  }

  savePedido () {
    this.carrito.items = this.items
    carritos.savePedido(this.carrito).then(() => {
      this.carrito = carritos.service.getEmpty(uuidv4())
      carritos.cleanItems()
      this.$router.push('/success')
    })
  }

  cleanCarrito () {
    this.carrito = carritos.service.getEmpty(uuidv4())
    carritos.cleanItems()
  }
}
